export enum ExcelValueFormatType {
  CURRENCY = "Currency",
  DATE = "Date",
  TEXT = "Text",
}